// extracted by mini-css-extract-plugin
export default {"checklistsCell":"bENe3rYtbMFqDhN1Dv5o","checklistsCell__colorIcon":"GbV96ymAPseb2RFXes6s","checklistsCell__name":"xrp4uqhoiMJ_tSxfOCys"};